import { isNull, isUndefined, set } from 'lodash';
import { SET_DATA } from 'helpers/Constants';

// Exported for tests
export const operators = {
  equal: (a, b) => {
    // eslint-disable-next-line eqeqeq
    return a == b;
  },
  contain: (array, value) => {
    return array.some((ele) => {
      // eslint-disable-next-line eqeqeq
      return ele == value;
    });
  },
  notContain: (array, value) => {
    return !array.some((ele) => {
      // eslint-disable-next-line eqeqeq
      return ele == value;
    });
  },
  exist: (value) => {
    return !(isUndefined(value) || isNull(value));
  }
};

// Exported for tests
export const logic = {
  evaluate: (rule, state) => {
    if (rule.logic === 'and') {
      return rule.rule.every((ele) => {
        return logic.evaluate(ele, state);
      });
    }
    if (rule.logic === 'or') {
      return rule.rule.some((ele) => {
        return logic.evaluate(ele, state);
      });
    }
    if (rule.logic === 'eval') {
      const prop = rule.property;
      switch (rule.operator) {
        case 'equal':
        case 'contain':
        case 'notContain':
          return operators[rule.operator](rule.triggerValue, state[prop]);
        case 'isValid':
          return !state?.errors?.[rule.property];
        case 'exist':
          return operators[rule.operator](state[prop]);
        default:
          return false;
      }
    }
    window?.Raven?.captureException(new Error('Rule missing logic'));
    return false;
  }
};

export const ruleExecutor = (rule, state, dispatch) => {
  if (logic.evaluate(rule, state)) {
    rule.targets.forEach((target) => {
      dispatch({
        type: SET_DATA,
        payload: set({}, target, rule.resultValue)
      });
    });
    return true;
  }
  rule.targets.forEach((target) => {
    if (rule.resetValue !== undefined) {
      dispatch({
        type: SET_DATA,
        payload: set({}, target, rule.resetValue)
      });
    }
  });
  return false;
};

export const ruleMiddleware = (storeAPI) => (next) => (action) => {
  const originalResult = next(action);
  const state = storeAPI.getState();
  Object.keys(action.payload).forEach((key) => {
    if (state?.triggers?.[key] && action.type === SET_DATA) {
      state.triggers[key].forEach((trigger) => {
        state.rules[trigger].forEach((rule) => {
          ruleExecutor(rule, state, storeAPI.dispatch);
        });
      });
    }
  });
  return originalResult;
};
